module.exports = __webpack_public_path__ + "img/Metastasis-INCA_10X_IC.aeeb8441.png";